// extracted by mini-css-extract-plugin
export default {"badge":"badges_badge__mM91d","dot":"badges_dot__lQ5LI"};